<section *ngIf="counter_data !== null">
  <div class="row">
    <div class="col" style="text-align: center; font-size: 30px;">
      Wallet Transaction
    </div>
    <div class="col-2" style="text-align: right;" (click)="closeClicked()">
      <button mat-button style="background: red; color: white;">Close</button>
    </div>
  </div><br>
  <div *ngIf="is_data_available">
    <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
    </mat-progress-spinner>
  </div>
  <div class="row">
    <div class="col">
      <label *ngIf="counter_data['opening_wallet_balance'] !== null" style="font-size: 25px">Opening Balance -
        {{counter_data['opening_wallet_balance']}}</label>
      <label *ngIf="counter_data['opening_wallet_balance'] == null" style="font-size: 25px">Opening Balance - 0</label>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <table class="table table-bordered table-hover">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Delivery Date</th>
            <th>Amount</th>
            <th>Ordered Date</th>
            <th>Wallet Balance</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of counter_data['wallet_transaction']; let counter_index=index">
            <td>{{ counter_index+1 }}</td>
            <td>{{ data['delivery_date'] }}</td>
            <td>{{ data['wallet_amount'] | currency: 'INR' }}</td>
            <td>{{ data['order_time'] | date: 'dd-MM-yyyy, h:mm a' }}</td>
            <td>{{ data['wallet_balance'] | currency: 'INR' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="row">
    <div class="col" style="font-size: 25px">
      <label *ngIf="counter_data['closing_wallet_balance'] !== null" style="font-size: 25px">Closing Balance -
        {{counter_data['closing_wallet_balance']}}</label>
      <label *ngIf="counter_data['closing_wallet_balance'] == null" style="font-size: 25px">Closing Balance - 0</label>
    </div>
  </div>
</section>
